import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UrlBuilder } from '../core';
import { Injectable } from '@angular/core';
import { first } from 'rxjs/operators';
import { UserStorage } from '../user';

@Injectable()
export class InvestigatorGuard implements CanActivate {

    constructor(private userStorage: UserStorage, private urlBuilder: UrlBuilder) {
    }

    public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        const user = await this.userStorage.currentUser
            .pipe(first())
            .toPromise();
        if (!user.isInvestigator) {
            this.urlBuilder.esa().navigate();
            return false;
        }

        return true;
    }
}